import { render, staticRenderFns } from "./CustomerPhone.vue?vue&type=template&id=ae797df2&"
import script from "./CustomerPhone.vue?vue&type=script&lang=js&"
export * from "./CustomerPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports